/**
 * PolyFill Module
 *
 * @since 1.0.0
 */

import 'objectFitPolyfill'

const PolyFill = function () {

}

export default PolyFill



// WEBPACK FOOTER //
// ./src/js/modules/PolyFill.js